import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { columnName, columnLink, columnTarget } from '@/constants/fields';
import TableWrapper from '@/components/table/TableWrapper';
import VocabularyLinksTableColumns from './VocabularyLinksTableColumns';
import VocabularyLinksTableRows from '../components/VocabularyLinksTableRows';
import VocabularyLinksTableFooter from './VocabularyLinksTableFooter';

const VocabularyLinksTable = ({
  columns = [columnName, columnLink, columnTarget],
  entity,
  updateErrors,
  urls,
}) => (
  <div className="aridhia-vocabulary-links-container">
    <TableWrapper sticky celled className="aridhia-vocabulary-links-table">
      <Table.Header fullWidth>
        <VocabularyLinksTableColumns columns={columns} entity={entity} errors={updateErrors} />
      </Table.Header>
      <Table.Body>
        <VocabularyLinksTableRows columns={columns} entity={entity} links={urls} />
      </Table.Body>
      <VocabularyLinksTableFooter colSpan={columns.length + 1} entity={entity} />
    </TableWrapper>
  </div>
);

const mapStateToProps = ({
  vocabularies: { activeVocabulary: { updateErrors, urls } },
}) => ({ updateErrors, urls });

export default connect(mapStateToProps)(VocabularyLinksTable);
